// stores/user-store.ts
import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'

export const useUserStore = defineStore('user', {
  state: () => ({
    userID: useStorage<number>('user:userID', 0),
    firstName: useStorage('user:firstName', ''),
    lastName: useStorage('user:lastName', ''),
    username: useStorage('user:username', ''),
    email: useStorage('user:email', ''),
    is2FAEnabled: useStorage('user:is2FAEnabled', false),
  }),

  actions: {
    setUser(data: any) {
      this.userID = data.userID
      this.firstName = data.firstName
      this.lastName = data.lastName
      this.username = data.username
      this.email = data.email
      this.is2FAEnabled = !!data.is2FAEnabled
    },
    logout() {
      this.userID = 0
      this.firstName = ''
      this.lastName = ''
      this.username = ''
      this.email = ''
      this.is2FAEnabled = false
    },
  },
})
